import { useAppSelector } from "../store/hooks";

/**
 * The ID of the partner currently selected.
 */
export const usePartnerID = () => useAppSelector(state => state.partners.selected.partner?.ID);

/**
 * The name of the partner currently selected.
 */
export const usePartnerName = () => useAppSelector(state => state.partners.selected.partner?.name);